// extracted by mini-css-extract-plugin
module.exports = {"subscriptionsContainer":"EG","subscriptionsTable":"FG","buttons":"GG","unsubscribeButton":"HG","disabled":"IG","saveButton":"JG","subscriptions":"KG","accountHeader":"LG"};